/**
 * This module exposes functionality related to showing/hiding of the LMS ad notice banner and related kafka tracking.
 *
 * The avro schema used is deployed in:
 * avro-schemas/trunk/avro-schemas/avro-schemas-tracking/schemas/tracking/events/settings/NoticeImpressionEvent.avsc
 */
import TrackingUtilsConstructor from '../../tracking/tracking-utils';

(function($, ss) {
  var Utils = ss.utils,
    TrackingUtils = new TrackingUtilsConstructor(),
    APP_ID = TrackingUtils.getAppId('lms_notice'),
    EVENT_TYPE = 'NoticeImpressionEvent',
    NOTICE_TYPE = 'ADS_ON_SLIDESHARE_PERSONALIZATION',
    COOKIE_KEY = 'lms_notice_shown';

  function LmsNotice() {
    this.$noticeWrapper = $('.j-lms-notice-wrapper');
    this.$closeButton = this.$noticeWrapper.find('.j-lms-notice-close');
    this.$closeButton.click(this.hide.bind(this));
  }

  LmsNotice.prototype = {
    constructor: LmsNotice,

    show: function() {
      if(cookie(COOKIE_KEY)) {
        return;
      }

      this.$noticeWrapper.removeClass('hide');
      this.recordImpression();

      // This GDPR notice only needs to be shown once every quarter
      cookie('lms_notice_shown', true, { expires: 90, path: '/', secure: true });
    },

    hide: function() {
      this.$noticeWrapper.addClass('hide');
    },

    recordImpression: function() {
      var data = {
        noticeType: NOTICE_TYPE,
        requestHeader: {
          pageKey: TrackingUtils.getPageKey()
        }
      };

      TrackingUtils.recordTrackingEvent(APP_ID, EVENT_TYPE, data, null);
    }
  };

  Utils.exports('slideview.LmsNotice', LmsNotice);
}(window.jQuery, window.slideshare_object));
